import { Component, OnInit, Input, OnDestroy, Inject, Output, EventEmitter, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { ProfileService } from '../profile.service';
import { ApiService } from '../api.service';
import { Subscription } from 'rxjs';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'dhhp-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.css']
})
export class MyProfileComponent implements OnInit, OnDestroy,OnChanges {
  editView: boolean = false;
  subscription: Subscription;
  profileName;
  profileView: boolean = true;
  @Input() drawyerData;
  userDetails: any;
  imageUrl;
  defaultuserIcon;
  @Input() profileUrl;
  @Output() emitEvent = new EventEmitter();
  isNotHartmannUser: boolean = true;
  @Input() logOutUrl;
  @Input() userprinciplename;
  @Input() role;
  @Input() userData;
  imm;
  @Input() institutionname;
  institutionList;
  institutionNameShow: any;
  @Input() isPlatform: boolean = false;
  @Input() isDisableSetting: boolean = false;
  translationKeys: typeof TranslationKeys = TranslationKeys;
  isSuperAdminOrCountryAdmin: boolean = false;
  constructor(private router: Router, private userdetailsservice: ProfileService, private apiService: ApiService) { }

  ngOnInit() {

    this.imm = this.userdetailsservice.hartmannIcon;
    /* temp value */
    // this.userDetails = {
    //   firstName: ""
    // }
    this.defaultuserIcon = this.userdetailsservice.defaultuserIcon;
    this.subscription = this.userdetailsservice.completeUserData$.subscribe(res => {
      this.imageUrl = res.profileImage;
    })
  }
  ngOnChanges(){
    if(this.userData){
      this.userDetails = this.userData;
      this.profileName = this.userData.name.charAt(0);
      this.isSuperAdminOrCountryAdmin = this.userData.roleName.roleId == 1 || this.userData.roleName.roleId == 2;
    }
    // if(this.userprinciplename)
    //   this.apiService.getUserProfile(this.userprinciplename).subscribe(res => {
    //     this.userDetails = res;
    //     this.profileName = this.userDetails.firstName.charAt(0) + '' + this.userDetails.lastName.charAt(0);
    //     if (this.userDetails.profileImage && this.userDetails.profileImage != '') {
    //       this.imageUrl = this.userDetails.profileImage;
    //     }
    //     if (res.userType == 'Hartmann' || res.userType == 'Developer') {
    //       this.isNotHartmannUser = false;
    //     }
    //   })

    if (this.institutionname && this.institutionname.length > 0) {
      this.institutionList = this.institutionname;
      var selectedInstitution = localStorage.getItem('selectedInstitution');
      if (selectedInstitution) {
        var institutionId = parseInt(selectedInstitution);
        var index = this.institutionname.findIndex(inst => inst.id == institutionId);
        if (index != -1) {
          this.institutionNameShow = this.institutionname[index].id;
        } else {
          this.institutionNameShow = this.institutionname[0].id;
        }
      } else {
        this.institutionNameShow = this.institutionname[0].id;
      }
    }
  }

  insChange(e){
    this.emitEvent.emit({event:'loadInstitution',value:e.value});
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  // redirect to Profile
  redirectToProfile(index) {
    if(index == 6 && !this.isNotHartmannUser){
      return false;
    }
    this.userdetailsservice.profileTabIndex.next(index);
    this.router.navigateByUrl(`/${this.profileUrl}`);
    if (this.drawyerData)
      this.drawyerData.toggle();

      this.emitEvent.emit({event:'submenuLinkClick'});
  }
  logout() {
    this.userdetailsservice.logout();
    //this.adminService.profileImage.next('');
    //this.router.navigateByUrl(this.logOutUrl);
    window.location.href = this.logOutUrl;
  }

}
